<div class="shipment-order-specs-container">
  <hmt-job-plan-order-header
    [showHeader]="showHeader"
    [showSearch]="showSearch"
    [orderCount]="filteredOrders?.length || 0"
    [(searchText)]="searchText"
    [showMoveDropdown]="showMoveDropdown"
    [containers]="containers"
    [selectedLoadId]="selectedLoadId"
    [showAddButton]="showAddButton"
    [jobType]="jobType"
    (searchTextChange)="onSearchChange()"
    (loadMoveClicked)="onLoadMoveClick($event)"
    (addButtonClicked)="onAddButtonClick()">
  </hmt-job-plan-order-header>

  <hmt-job-plan-order-sorting
    [hasOrders]="orders.length > 0"
    [showControls]="orders.length > 0 || hasActiveFilter"
    [(sortBy)]="sortBy"
    [(sortOrder)]="sortOrder"
    [(groupBy)]="groupBy"
    [activeFiltersCount]="getActiveFiltersCount()"
    [selectAllChecked]="isSelectAllChecked()"
    [selectAllIndeterminate]="isSelectAllIndeterminate()"
    [hideCheckboxes]="hideCheckboxes"
    (sortByChange)="onSortByChange()"
    (sortOrderChange)="onSortOrderChange()"
    (groupByChange)="onGroupByChange()"
    (openFilters)="openOtherFilters($event)"
    (selectAllChange)="onSelectAllChange($event)">
  </hmt-job-plan-order-sorting>

  <div class="orders-table">
    <!-- Grouped Display -->
    <ng-container *ngIf="groupBy !== 'none' && groupedOrders.length > 0">
      <ng-container *ngFor="let group of groupedOrders">
        <!-- Figma node 2585:47352 — consignee group card -->
        <div class="group-container">
          <div class="group-header" (click)="toggleGroupExpand(group.groupKey)">
            <div class="group-avatar" aria-hidden="true">
              <span class="group-avatar-initial">{{ getGroupInitial(group.groupKey) }}</span>
            </div>
            <span class="group-label">{{ group.groupKey }}</span>
            <div class="group-right-section">
              <span class="group-count-badge">{{ group.orders.length }}</span>
              <button
                type="button"
                class="group-expand-btn"
                [class.expanded]="isGroupExpanded(group.groupKey)"
                [attr.aria-expanded]="isGroupExpanded(group.groupKey)"
                [attr.aria-label]="isGroupExpanded(group.groupKey) ? 'Collapse group' : 'Expand group'">
                <img
                  class="group-arrow-icon"
                  src="assets/booking-engine/icons/arrow-drop.svg"
                  alt=""
                  aria-hidden="true"
                  width="20"
                  height="20" />
              </button>
            </div>
          </div>

          <div class="group-panel" *ngIf="isGroupExpanded(group.groupKey)">
            <div class="group-table-header" role="row">
              <span class="gth-cell gth-lead" aria-hidden="true"></span>
              <span class="gth-cell">Order Id</span>
              <span class="gth-cell">Consignee</span>
              <span class="gth-cell">Total Volume</span>
              <span class="gth-cell">Total Weight</span>
              <span class="gth-cell gth-placeholder" aria-hidden="true"></span>
              <span class="gth-cell gth-placeholder" aria-hidden="true"></span>
            </div>
            <div class="group-orders-list">
              <ng-container *ngFor="let order of group.orders; let i = index">
                <div class="table-row"
                  [class.expanded]="isExpanded(order.orderId)"
                  [class.selected]="isOrderSelected(order.orderId) || isOrderPartiallySelected(order.orderId)"
                  (click)="toggleExpand(order.orderId)">
                  <hmt-job-plan-order-row
                    [order]="order"
                    [expanded]="isExpanded(order.orderId)"
                    [selected]="isOrderSelected(order.orderId)"
                    [partiallySelected]="isOrderPartiallySelected(order.orderId)"
                    [deletable]="false"
                    [hideCheckbox]="hideCheckboxes"
                    (expandToggle)="toggleExpand(order.orderId)"
                    (checkboxChange)="onSelectOrder(order, { checked: $event })"
                    (deleteOrder)="onDeleteOrder(order, $event)">
                  </hmt-job-plan-order-row>

                  <hmt-job-plan-order-details
                    *ngIf="isExpanded(order.orderId)"
                    [order]="order"
                    [orderSelected]="isOrderSelected(order.orderId)"
                    [hideCheckboxes]="hideCheckboxes"
                    (skuSelectionChanged)="onSkuSelectionChanged(order.orderId, $event.selectedCount, $event.totalCount)"
                    (skuItemSelected)="onSkuItemSelected(order.orderId, $event)"
                    (skuQuantityChanged)="onSkuQuantityChanged(order.orderId, $event)">
                  </hmt-job-plan-order-details>
                </div>

                <div class="row-separator" *ngIf="i < group.orders.length - 1"></div>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <!-- Non-Grouped Display -->
    <ng-container *ngIf="groupBy === 'none'">
    <ng-container *ngFor="let order of filteredOrders; let i = index">
      <div class="table-row" 
           [class.expanded]="isExpanded(order.orderId)"
           [class.selected]="isOrderSelected(order.orderId) || isOrderPartiallySelected(order.orderId)"
           (click)="toggleExpand(order.orderId)">
        <hmt-job-plan-order-row
          [order]="order"
          [expanded]="isExpanded(order.orderId)"
          [selected]="isOrderSelected(order.orderId)"
          [partiallySelected]="isOrderPartiallySelected(order.orderId)"
          [deletable]="deletable"
          [hideCheckbox]="hideCheckboxes"
          (expandToggle)="toggleExpand(order.orderId)"
          (checkboxChange)="onSelectOrder(order, { checked: $event })"
          (deleteOrder)="onDeleteOrder(order, $event)">
        </hmt-job-plan-order-row>

        <!-- Expandable Detail Section -->
        <hmt-job-plan-order-details
          *ngIf="isExpanded(order.orderId)"
          [order]="order"
          [orderSelected]="isOrderSelected(order.orderId)"
          [hideCheckboxes]="hideCheckboxes"
          (skuSelectionChanged)="onSkuSelectionChanged(order.orderId, $event.selectedCount, $event.totalCount)"
          (skuItemSelected)="onSkuItemSelected(order.orderId, $event)"
          (skuQuantityChanged)="onSkuQuantityChanged(order.orderId, $event)">
        </hmt-job-plan-order-details>
      </div>

      <!-- Separator Line -->
      <div class="row-separator" *ngIf="i < filteredOrders.length - 1"></div>
      </ng-container>
    </ng-container>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="filteredOrders.length === 0 && showSearch && (searchText || getActiveFiltersCount() > 0)">
      <mat-icon class="empty-icon">search_off</mat-icon>
      <div class="empty-text">No orders found</div>
      <div class="empty-subtext">Try adjusting your search criteria</div>
    </div>
  </div>
</div>

